import { clearPermissions } from 'helpers/utilHelpers';

export default function clearSavedData() {
  clearPermissions();
}
